import { useEffect, useState } from "react";

/**
 * Tracks the browser's online/offline state via the `online`/`offline`
 * window events plus the initial `navigator.onLine` hint.
 *
 * navigator.onLine is famously overoptimistic (it just means the device has
 * *a* network interface), but the events fire reliably when the underlying
 * connection flaps - which is the scenario we actually care about in a
 * flaky conference Wi-Fi room.
 */
export function useOnline() {
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true
  );

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  return online;
}
